import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Text from "@pathwright/ui/src/components/ui/Text"
import View from "@pathwright/ui/src/components/ui/View"
import { WithCSS } from "@pathwright/ui/src/components/utils/styles"
import { css } from "styled-components"
import { getStepVerbIcon } from "../../utils"

const PathStep = ({ step, onEnterStep }) => {
  function handleEnterStep(e) {
    if (typeof onEnterStep === "function") {
      e.preventDefault()
      e.stopPropagation()
      onEnterStep(step.source_id, e.currentTarget.getBoundingClientRect())
    }
  }
  const metaParts = []
  if (step && step.is_required === false) metaParts.push("Optional")
  if (step && step.time_to_complete) metaParts.push(step.time_to_complete)
  if (step && step.userpoints_value)
    metaParts.push(`${step.userpoints_value} Points`)
  return (
    <WithCSS as={View.Primary} css={styles.container} className={`PathStep`} data-source-id={step.source_id} onClick={handleEnterStep}>
      <WithCSS as={Text.Meta} css={styles.icon} style={{ marginRight: 10 }}>
        {(step.verb || step.step_verb) && (
          <Pathicon icon={getStepVerbIcon(step.verb || step.step_verb)} />
        )}
      </WithCSS>
      <WithCSS as="div" css={styles.text}>
        <WithCSS
          as={Text.Body}
          css={styles.title}
          style={{ fontWeight: "700", fontSize: "16px", color: "#222" }}
        >
          {step.name}
        </WithCSS>
        {metaParts.length > 0 ? (
          <WithCSS as={"small"} css={styles.meta}>
            {metaParts.join(" • ")}
          </WithCSS>
        ) : null}
      </WithCSS>
    </WithCSS>
  )
}

PathStep.displayName = "PathStep"

export default PathStep

const styles = {
  container: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 20px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    &:first-of-type {
      border-top: none;
    }
  `,
  icon: css`
    margin-right: 10px;
  `,
  text: css`
    display: flex;
    flex-direction: column;
    min-width: 0;
    overflow: hidden;
  `,
  title: css`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  meta: css`
    margin-top: 2px;
    color: #888;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px !important;
  `
}
